module.exports = __webpack_public_path__ + "d530e53d5876d04e018c4de220ed8444.svg";